/** Must match RimalWebStore checkout conversion (VITE_SYP_PER_USD). */
export const SYP_PER_USD = Number(import.meta.env.VITE_SYP_PER_USD) || 15_000;
